import { Box, Link } from '@mui/material';
import { getStyles } from './css/FooterStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ExternalLinks from '../../../shared/externalLinks';

const Footer = () => {
    const isDesktopOrLaptop = useMediaQuery('(min-width:1224px)');
    const styles = getStyles(isDesktopOrLaptop);

    return (
        <Box sx={styles.root}>
            <Box sx={styles.contentContainer}>
                <Link sx={styles.logoLink}>
                    <img onClick={() => { window.location.href = (ExternalLinks.MARKETING.HOME) }} alt="Aipex Logo (gray)" src={ExternalLinks.AIPEX_LOGO}></img>
                </Link>
                <Link sx={styles.contactLink} href={ExternalLinks.MARKETING.ABOUT.CONTACT}>Contact Our Team</Link>
                <Box sx={styles.copyrightText}>© Copyright 2023 AIPEX Technologies, Inc</Box>
                <Box sx={styles.copyrightText}>AIPEX™ is a trademark of AIPEX Technologies, Inc</Box>
                <Box>
                    <Box sx={styles.privacyPolicySection}>
                        <Box sx={styles.patentText}>Patents Granted and Pending</Box>
                        <Box sx={styles.verticalDivider}>|</Box>
                        <Link href={ExternalLinks.MARKETING.PRIVACY} sx={styles.privacyPolicyLink}>Privacy Policy</Link>
                        <Box sx={styles.verticalDivider}> | </Box>
                        <Link href={ExternalLinks.MARKETING.TERMS} sx={styles.privacyPolicyLink}>Terms of Use</Link>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default Footer;